export default "__VITE_ASSET__ChC9qFkz__"